import { RouteName } from 'src/routes/config';
export const tabLinks = [{
  id: RouteName.Staking,
  label: 'Staking'
}, {
  id: RouteName.YourStaking,
  label: 'My Staking'
}];